// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-a9f70732] option[disabled]{color:rgba(55,59,60,.5)}", "",{"version":3,"sources":["webpack://./resources/client/components/form/FormFieldSelect.vue"],"names":[],"mappings":"AAGA,mCACE,uBAFF","sourcesContent":["\n@import \"../../styles/variables/variables\";\n\n::v-deep option[disabled] {\n  color: $text-light;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
